/* eslint-disable no-restricted-globals */
import { throttle } from 'throttle-debounce';

/**
 *
 * @param samplesSelector
 * @param previewBlockSelector
 * @param infoBlockSelector
 * @param marginLeft
 * @param marginTop
 * @constructor
 */
const SamplesInfo = ({
  samplesSelector = '[data-samples-item]',
  previewBlockSelector = '[data-sample-preview]',
  infoBlockSelector = '[data-sample-info]',
  marginLeft = 0,
  marginTop = 30,
}) => {
  const samples = document.querySelectorAll(samplesSelector);
  if (!samples || isNaN(marginLeft) || isNaN(marginTop)) return;

  [].slice.call(samples).forEach((item) => {
    const previewBlock = item.querySelector(previewBlockSelector);
    const infoBlock = item.querySelector(infoBlockSelector);
    if (!previewBlock && !infoBlock) return;

    let X = 0;
    let Y = 0;

    const throttled = throttle(50, () => {
      infoBlock.style.left = `${X + marginLeft}px`;
      infoBlock.style.top = `${Y + marginTop}px`;
    });

    previewBlock.addEventListener('mouseover', (e) => {
      X = e.clientX;
      Y = e.clientY;

      throttled();

      infoBlock.classList.add('show');
    }, false);

    previewBlock.addEventListener('mousemove', (e) => {
      X = e.clientX;
      Y = e.clientY;

      throttled();
    }, false);

    previewBlock.addEventListener('mouseout', () => {
      infoBlock.classList.remove('show');
    }, false);
  });
};

export default SamplesInfo;
